import { Reducer } from 'redux'
import { ExternalCourseCertificate } from 'models/externalCourseCertificate.model'
import * as fromActions from '../actions/externalCourseCertificate.action'
import { ExternalCourseCertificateState } from '../states/externalCourseCertificate.state'

export const initialState: ExternalCourseCertificateState = {
  list: [],
  loading: true,
}

type AdministrationListSuccess = {
  type: typeof fromActions.EXTERNAL_COURSE_CERTIFICATES_GET_LIST_SUCCESS
  payload: {
    data: ExternalCourseCertificate[]
  }
}

type Loading = {
  type:
    | typeof fromActions.EXTERNAL_COURSE_CERTIFICATES_GET_LIST
    | typeof fromActions.EXTERNAL_COURSE_CERTIFICATES_LOADING
  payload: {
    loading: boolean
  }
}

export type ReducerActions = AdministrationListSuccess | Loading

export const reducer: Reducer<ExternalCourseCertificateState, ReducerActions> =
  (
    state: ExternalCourseCertificateState = initialState,
    action
  ): ExternalCourseCertificateState => {
    switch (action.type) {
      case fromActions.EXTERNAL_COURSE_CERTIFICATES_GET_LIST_SUCCESS: {
        const { data } = action.payload
        return {
          ...state,
          list: data,
          loading: false,
        }
      }
      case fromActions.EXTERNAL_COURSE_CERTIFICATES_GET_LIST:
        return {
          ...state,
          loading: true,
        }
      case fromActions.EXTERNAL_COURSE_CERTIFICATES_LOADING: {
        const { loading } = action.payload
        return {
          ...state,
          loading,
        }
      }

      default:
        return state
    }
  }
